export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8864.74c2e990.jpg";